const notFound = r => require.ensure([], () => r(require('../views/404.vue')), 'notFound')
const consultationLogin = r => require.ensure([], () => r(require('../views/pageTransfer.vue')), 'consultationLogin')
const login = r => require.ensure([], () => r(require('../views/Login.vue')), 'login')
const layout = r => require.ensure([], () => r(require('../layout/index.vue')), 'layout')
const home = r => require.ensure([], () => r(require('../views/Home.vue')), 'home')
const userinfo = r => require.ensure([], () => r(require('../views/system/userInfo.vue')), 'userinfo')
const ddverify = r => require.ensure([], () => r(require('../views/ddverify/index.vue')), 'ddverify')
const resetpassword = r => require.ensure([], () => r(require('../views/Resetpassword.vue')), 'resetpassword')

let routes = [
  { path: '*', redirect: { path: '/404' }, name: '404', hidden: true },
  { path: '/web/index.html', redirect: { path: '/login' }, hidden: true },
  { path: '/consultationLogin', component: consultationLogin, name: '登录', hidden: true },
  { path: '/login', component: login, name: '登录', hidden: true },
  { path: '/ddverify', component: ddverify, name: '钉钉用户身份验证', hidden: false },
  { path: '/404', component: notFound, name: '404', hidden: true },
  {
    path: '/', component: layout, name: '主页', hidden: true, redirect: '/hospital/listmy', children: [
      { path: 'home', component: home, name: '首页', hidden: true, meta: { title: '首页' } },
      { path: 'updatepwd', component: resetpassword, name: '修改密码', hidden: true, meta: { title: '修改密码' } },
      { path: 'userinfo', component: userinfo, name: '个人信息', hidden: true, meta: { title: '个人信息' } }
    ]
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/modules/web/router/routes.js